module.exports = __webpack_public_path__ + "static/media/Frosinone.4020b68a.png";